export const info = {
	name: '邱宇瑨 ／ Jeserlin Chiu',
	job: 'Software Engineer',
	email: 'jeserlin@me.com',
	wordPress: 'jeserlin.wordpress.com',
	github: 'github.com/jeserlin',
	welcome: 'Welcome to my résume! This résume is made with React!',
	bye: 'Thanks for visiting my website!'
};


// WEBPACK FOOTER //
// ./src/data/InfoFile.js